<div class="container-fluid p-3">
  <div class="d-flex justify-content-end align-items-end">
    <button class="btn btn-info" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      @if (isCollapsed) {
        <i class="fas fa-chevron-circle-down"></i>
      }
      @if (isCollapsed == false) {
        <i class="fas fa-chevron-circle-up"></i>
      }
    </button>
  </div>

  <div class="collapse" id="collapseExample" [ngbCollapse]="isCollapsed">
    <app-report-generator [selectedCompany]="selectedCompany"></app-report-generator>
  </div>
  <h2>Overdue EPF Report</h2>

  <p [hidden]="reportList.length > 0">Congratulations! All your Form Js are up to date!</p>

  <div [hidden]="reportList.length == 0">
    <table class="table table-striped mt-2">
      <thead>
        <tr>
          <td>Customer Name</td>
          <td>Customer IC</td>
          <td>EPF Date</td>
        </tr>
      </thead>
      <tbody>
        @for (report of reportList; track report) {
          <tr>
            <td class="customerCol" (click)="goToCustomer(report.customerID)">{{ report.customerName }}</td>
            <td>{{ sharedService.processICNum(report.customerIC) }}</td>
            <td>{{ report.epfDate | date: "dd-MM-yyyy" }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
